import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as loginFormReducers from "./login-form.reducer";
import * as userProfileReducers from "./login-profile.reducer";
import * as loginRegisterReducers from "./login-register.reducer";
import * as languagesReducers from "./languages.reducer";

// state tree branches
export interface UserState {
    login: loginFormReducers.LoginFormState;
    profile: userProfileReducers.ProfileState;
    register: loginRegisterReducers.RegisterState;
    languages: languagesReducers.LanguagesState;
}

// register reducer
export const reducers: ActionReducerMap<UserState> = {
    login: loginFormReducers.reducer,
    profile: userProfileReducers.reducer,
    register: loginRegisterReducers.reducer,
    languages: languagesReducers.reducer
};

// Top level in state tree for branch
export const getUserModuleState = createFeatureSelector<UserState>("user");
